import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch,Redirect } from "react-router-dom";
import ReactDOM from 'react-dom';
import AllPosts from "./blog/AllPosts.js";
import OnePost from "./blog/OnePost.js";
import AuthorPage from './blog/AuthorPage.js';
import PreviewPost from "./blog/PreviewPost.js";
import SiteFooter from './components/SiteFooter.js';
import SiteHeader from './components/SiteHeader.js';
import SideBar from './components/SideBar';
import { CommonUtil } from './utils/CommonUtil';

import { ReactGAInstance } from './connectors/ReactGAInstance.js';
import { PremiumUtil } from './utils/PremiumUtil.js';
import { BlurMessages } from './BlurMessages.js';

import AdSenseSettings from './utils/AdSenseSettings';

import 'semantic-ui-less/semantic.less';
import './theme/custom.css';
import './theme/blog.css';

var constVars = require('./utils/Const');

class BlogApp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageUrl: "",
      updated: false,
      loading: false,
    }
    this.translateLang = CommonUtil.lang;
  }
  componentDidMount() {
    window.addEventListener('resize', this.findDeviceType.bind(this));
    this.findDeviceType();
    this.setPageUrl();
    this.translateLang = CommonUtil.lang;
    this.translate();
    ReactGAInstance.PageView(this.props.location.pathname);
    PremiumUtil.PingExtension().then().catch().then(() => {
      this.setState(c=> {
        c.loading = false;
        return c;
      })
    });
  }
  componentDidUpdate(prevProps) {
    if(this.props.location !== prevProps.location) {
      this.translateLang = CommonUtil.lang;
      this.translate();
      this.setState(c => {
        c.updated = true;
        return c;
      });
      ReactGAInstance.PageView(this.props.location.pathname)
    };
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.findDeviceType.bind(this));
  }
  findDeviceType() {
    this.setState(c=> {
      c.deviceType = AdSenseSettings.getDeviceType();
      return c;
    });
  }
  setPageUrl() {
    this.setState(c => {
      c.pageUrl = encodeURIComponent(window.location.href);
      return c;
    })
  }
  translate() {
    BlurMessages.init(this.translateLang).then(() => {
      BlurMessages.translate();
    }).catch((err) => {
        //do nothing right now
    });
  }
  setLanguage(match) {
    CommonUtil.SetLanguage(match.params.lang);
    if(this.translateLang !== CommonUtil.lang) {
      this.translateLang = CommonUtil.lang;
      this.setState(c => {
        c.updated = true;
        return c;
      });
    }
  }
  renderRedirect(match, location, hasLang=false) {
    let pathname = "/" + CommonUtil.lang + location.pathname + location.search;
    if(hasLang) {
      let paths = location.pathname.split("/");
      paths.splice(1, 1);
      pathname = "/" + CommonUtil.lang + paths.join("/") + location.search;
    }
    return <Redirect to={pathname}/>
  }
  renderRoutes(match, location) {
    let lang = match.params.lang;
    if(lang === "safety") {
      return <Redirect to={"/" + CommonUtil.lang + "/blog"}/>
    }
    if(lang === "blog") {
      return this.renderRedirect(match, location);
    }
    let subLang = match.params.lang;
    if(lang && lang.length === 5) {
      subLang = lang.substr(0, 2);
    }
    if(constVars.languages.some(s => (s.code.toLowerCase() === lang.toLowerCase() || s.code.toLowerCase() === subLang.toLowerCase()))) {
      this.setLanguage(match);
      return (
        <>
        <Switch>
          <Route component={AllPosts} path="/:lang/blog" exact />
          <Route component={PreviewPost} path="/:lang/blog/preview/:slug" />
          <Route component={AuthorPage} path="/:lang/blog/author/:authorSlug" />
          <Route component={OnePost} path="/:lang/blog/:slug" />
        </Switch>
        </>
      )
    } else {
      return this.renderRedirect(match, location, true);
    }
  }
  getSocialMediaLink(name) { // https://www.sharelinkgenerator.com/
    if (name == "facebook") {
      return `https://www.facebook.com/sharer/sharer.php?u=${this.state.pageUrl}`;
    } else if (name == "linkedin") {
      return `https://www.linkedin.com/shareArticle?mini=true&url=${this.state.pageUrl}`;
    } else if (name == "twitter") {
      return `https://twitter.com/intent/tweet?text=${this.state.pageUrl}`;
    }
  }
  render() {
    //making sure we got the cookie first thru pingExtension call in componentDidMount
    if (this.state.loading) {
      return ( 
        <div className="Site">
          <div className="Site-content"></div>
        </div>
      )
    }
    return (
      <div className="Site">
        <SiteHeader {...this.props} updated={this.state.updated}/>
        <div className="Site-content">
          <div className="page-content">
            <div className="blog-header-wrap">
              <div className="blog-header-links">
                <div className="blog-header-link">
                  <a href="/blog">Blog home</a>
                </div>
                <div className="blog-header-share-icons">
                  <a href={this.getSocialMediaLink("facebook")}><i className="facebook icon"/></a>
                  <a href={this.getSocialMediaLink("linkedin")}><i className="linkedin icon"/></a>
                  <a href={this.getSocialMediaLink("twitter")}><i className="twitter icon"/></a>
                </div>
              </div>
            </div>
            <Switch>
              <Route path="/:lang/">
                {({match, location}) => (this.renderRoutes(match, location))}
              </Route>
              <Route path="*">
                {({match, location}) => this.renderRedirect(match, location)}
              </Route>
            </Switch>
          </div>
          <SideBar {...this.props}  updated={this.state.updated} deviceType={this.state.deviceType} />
        </div>
        <SiteFooter {...this.props}  updated={this.state.updated}/>
      </div>
    );
  }
}

class BlogIndex extends Component {
    render() {
      return (
        <Router onChange={() => {this.setPageUrl();}}>
          <Route component={BlogApp} />
        </Router>
      );
    }
}
ReactGAInstance.Initialize();
ReactDOM.render(<BlogIndex />, document.getElementById('root'));
  